<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Edit Customer" scrollable hide-footer>
            <template v-slot:modal-title>
                <span>Edit Customer:</span>
            </template>

            <b-form v-if="ready" @submit.stop.prevent="editCustomer">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="edit.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-company"
                            label="Company:"
                            label-for="input-company"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-company"
                                v-model="edit.company"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-buyer-name"
                                    label="Buyer Name:"
                                    label-for="input-buyer-name"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-buyer-name"
                                        v-model="edit.buyerName"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="select-group-sales-rep"
                                    label="Sales Rep:"
                                    label-for="select-sales-rep"
                                    label-size="sm"
                                >
                                    <b-form-select
                                        v-model="edit.salesRepId"
                                        id="select-sales-rep"
                                        size="sm"
                                        :options="lists.salesReps"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="edit.email"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-phone"
                                    label="Phone:"
                                    label-for="input-phone"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-phone"
                                        v-model="edit.phone"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-mobile"
                                    label="Mobile:"
                                    label-for="input-mobile"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-mobile"
                                        v-model="edit.mobile"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-fax"
                                    label="Fax:"
                                    label-for="input-fax"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-fax"
                                        v-model="edit.fax"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <!-- <b-col cols="4">
                                <b-form-group
                                    id="input-group-other"
                                    label="Other:"
                                    label-for="input-other"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-other"
                                        v-model="edit.other"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col> -->
                            <b-col cols="12">
                                <b-form-group
                                    id="input-group-website"
                                    label="Website:"
                                    label-for="input-website"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-website"
                                        v-model="edit.website"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>

                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Address" active>
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <p>Billing Address:</p>
                                        <b-form-group
                                            id="textarea-group-billing-address-1"
                                        >
                                            <b-form-input
                                                id="input-billing-address-1"
                                                v-model="edit.billingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-billing-address-2"
                                        >
                                            <b-form-input
                                                id="input-billing-address-2"
                                                v-model="edit.billingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-city"
                                                >
                                                    <b-form-input
                                                        id="input-billing-city"
                                                        v-model="edit.billingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-state"
                                                >
                                                    <b-form-input
                                                        id="input-billing-state"
                                                        v-model="edit.billingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-zip"
                                                >
                                                    <b-form-input
                                                        id="input-billing-zip"
                                                        v-model="edit.billingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-country"
                                                >
                                                    <b-form-input
                                                        id="input-billing-country"
                                                        v-model="edit.billingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                    <b-col>
                                        <p>Shipping Address:</p>
                                        <b-form-group
                                            id="textarea-group-shipping-address-1"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-1"
                                                v-model="edit.shippingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-shipping-address-2"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-2"
                                                v-model="edit.shippingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-city"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-city"
                                                        v-model="edit.shippingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-state"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-state"
                                                        v-model="edit.shippingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-zip"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-zip"
                                                        v-model="edit.shippingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-country"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-country"
                                                        v-model="edit.shippingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Notes">
                            <b-card-text>
                                <b-form-group
                                    id="textarea-group-notes"
                                    label="Notes:"
                                    label-for="textarea-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-notes"
                                        v-model="edit.notes"
                                        placeholder=""
                                        rows="7"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Tax Info">
                            <b-card-text>
                                <b-form-group
                                    id="input-group-reseller-permit"
                                    label="Reseller Permit #:"
                                    label-for="input-reseller-permit"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-reseller-permit"
                                        v-model="edit.resellersPermit"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Preferred Payment & Delivery">
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="select-group-payment-method"
                                            label="Preferred Payment Terms:"
                                            label-for="select-payment-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="edit.paymentMethod"
                                                id="select-payment-method"
                                                size="sm"
                                                :options="lists.paymentMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                        <b-form-group
                                            id="select-group-delivery-method"
                                            label="Preferred Delivery Method:"
                                            label-for="select-delivery-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="edit.deliveryMethod"
                                                id="select-delivery-method"
                                                size="sm"
                                                :options="lists.deliveryMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-opening-balance"
                                                    label="Opening Balance:"
                                                    label-for="input-opening-balance"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-opening-balance"
                                                        v-model="edit.openingBalance"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <!-- <b-form-group
                                                    id="datepicker-group-opening-balance-date"
                                                    label="as of:"
                                                    label-for="datepicker-opening-balance-date"
                                                    label-size="sm"
                                                >
                                                    <b-form-datepicker
                                                        id="datepicker-opening-balance-date"
                                                        v-model="edit.openingBalanceDate"
                                                        class="mb-2"
                                                        size="sm"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        locale="en"
                                                    >
                                                    </b-form-datepicker>
                                                </b-form-group> -->
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Cards On File" v-if="$can('edit-customer-detail-payment-method') || $can('view-all')">
                            <b-card-text>
                                <b-table-simple hover small bordered>
                                    <b-thead>
                                        <b-th class="default-card"></b-th>
                                        <b-th style="min-width: 220px; width: 220px;">Number</b-th>
                                        <b-th>Exp</b-th>
                                        <b-th>CVC {{ paymentConfig.cvc_required ? '(Required)' : '(Optional)' }}</b-th>
                                        <b-th>Kaja</b-th>
                                        <b-th></b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="(card, index) in lists.cards" :key="index">
                                            <b-td :class="{ 'highlight-green': card.default }" />
                                            <b-td>
                                                <b-form-input :id="'input-cards-number' + row.id" :value="formatCardDisplay(card.number, 'number')" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-exp' + row.id" :value="formatCardDisplay(card.exp, 'exp')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-cvc' + row.id" :value="formatCardDisplay(card.cvc, 'cvc')" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td class="text-center">
                                                <span v-if="card.kaja_payment_method_id">
                                                    <i class="fa fa-check text-success"></i>
                                                </span>
                                                <span v-else>
                                                    <i class="fa fa-times text-danger"></i>
                                                </span>
                                            </b-td>
                                            <b-td>
                                                <b-button class="btn-sm" v-if="!card.default" @click="makeDefault(card.id)">Make Default</b-button>
                                                <b-button variant="danger" class="btn-sm" v-if="!card.default" @click="deleteCard(card.id)">X</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-td></b-td>
                                                                                         <b-td>
                                                 <b-form-input 
                                                     id="input-new-number" 
                                                     v-model="edit.new.number" 
                                                     type="text" 
                                                     size="sm" 
                                                     autocomplete="off"
                                                     @input="formatCardNumber"
                                                     placeholder="Card number (no spaces)"
                                                 />
                                             </b-td>
                                                                                         <b-td>
                                                 <b-form-input 
                                                     id="input-new-exp" 
                                                     v-model="edit.new.exp" 
                                                     type="text" 
                                                     size="sm" 
                                                     autocomplete="off"
                                                     @input="formatExpiry"
                                                     placeholder="MM/YY"
                                                 />
                                             </b-td>
                                             <b-td>
                                                 <b-form-input 
                                                     id="input-new-cvc" 
                                                     v-model="edit.new.cvc" 
                                                     type="text" 
                                                     size="sm" 
                                                     autocomplete="off"
                                                     @input="formatCVC"
                                                     :placeholder="paymentConfig.cvc_required ? 'CVC' : 'CVC (Optional)'"
                                                 />
                                             </b-td>
                                            <b-td>
                                                <b-button v-if="edit.new.number && edit.new.exp" variant="success" class="btn-sm" @click="createCard">SAVE</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tfoot>
                                </b-table-simple>
                                
                                <!-- Permission notice -->
                                <div v-if="!($can('view-customer-detail-payment-method-full-card') || $can('view-all'))" class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-info-circle"></i> 
                                        Card details are masked. Contact your administrator for full access to view complete card information.
                                    </small>
                                </div>
                                
                                <!-- CVC requirement notice -->
                                <div class="mt-2">
                                    <small class="text-muted">
                                        <i class="fas fa-info-circle"></i> 
                                        CVC is currently {{ paymentConfig.cvc_required ? 'required' : 'optional' }} for card creation.
                                    </small>
                                </div>
                            </b-card-text>
                        </b-tab>
                        <!-- <b-tab title="Additional Info">
                            <b-card-text></b-card-text>
                        </b-tab> -->
                        <b-tab title="Sources">
                            <b-card-text>
                                <b-card no-body>
                                    <b-tabs pills card vertical>
                                        <b-tab :title="source.source && source.source.name ? source.source.name : 'Unknown Source'" :active="index == 0" v-for="(source, index) in idTracker" :key="index">
                                            <b-card-text>
                                                <b-table-simple hover small fixed bordered>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <td class="sources-first-col">ID:</td>
                                                            <td>{{ source.source_reference_id }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source && source.source.source_type && source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>Username:</td>
                                                            <td>{{ row.username }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source && source.source.source_type && source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>E-mail:</td>
                                                            <td>{{ row.email }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source && source.source.source_type && source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>Password:</td>
                                                            <td>
                                                                <b-row>
                                                                    <b-col>
                                                                        <b-form-input
                                                                            id="input-reset-password"
                                                                            v-model="newPassword"
                                                                            type="password"
                                                                            placeholder=""
                                                                            size="sm"
                                                                            autocomplete="off"
                                                                        >
                                                                        </b-form-input>
                                                                    </b-col>
                                                                    <b-col>
                                                                        <b-button variant="danger" size="sm" @click="resetPassword(source.sources_id, source.source_reference_id)" :disabled="!newPassword || submittingUnlink == 1">
                                                                            <span v-if="submittingPassword">
                                                                                <b-spinner small type="grow"></b-spinner>
                                                                                Resetting...
                                                                            </span>
                                                                            <span v-else>Reset Password</span>
                                                                        </b-button><br><br>
                                                                        <b-button variant="danger" size="sm" @click="unlinkSource(source.id, source.sources_id, source.source_reference_id)">
                                                                            <span v-if="submittingUnlink">
                                                                                <b-spinner small type="grow"></b-spinner>
                                                                                Unlinking...
                                                                            </span>
                                                                            <span v-else>Unlink Source</span>
                                                                        </b-button>
                                                                    </b-col>
                                                                </b-row>
                                                            </td>
                                                        </b-tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-card-text>
                                        </b-tab>
                                        <b-tab tag="hr" disabled></b-tab>
                                        <b-tab title="Create Woo User" v-if="!row.username">
                                            <b-card-text>
                                                <b-form-group
                                                    id="input-group-new-user-username"
                                                    label="Username:"
                                                    label-for="input-new-user-username"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-new-user-username"
                                                        v-model="newUser.username"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-form-group
                                                    id="input-group-new-user-password"
                                                    label="Password:"
                                                    label-for="input-new-user-password"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-new-user-password"
                                                        v-model="newUser.password"
                                                        type="password"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-button variant="success" size="sm" @click="createNewUser">
                                                    <span v-if="submittingNewUser">
                                                        <b-spinner small type="grow"></b-spinner>
                                                        Creating User...
                                                    </span>
                                                    <span v-else>Create User</span>
                                                </b-button>
                                            </b-card-text>
                                        </b-tab>
                                        <b-tab tag="hr" disabled></b-tab>
                                        <b-tab title="Map Woo User" v-if="!row.username">
                                            <b-card-text>
                                                <b-form-group
                                                    id="input-group-map-userid"
                                                    label="Woo User ID:"
                                                    label-for="input-map-userid"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-map-userid"
                                                        v-model="mapUser.id"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-form-group
                                                    id="input-group-map-username"
                                                    label="Woo Username:"
                                                    label-for="input-map-username"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-map-username"
                                                        v-model="mapUser.username"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-button variant="success" size="sm" @click="mapUserId">
                                                    <span v-if="submittingMapUserId">
                                                        <b-spinner small type="grow"></b-spinner>
                                                        Mapping User ID...
                                                    </span>
                                                    <span v-else>Map User ID</span>
                                                </b-button>
                                            </b-card-text>
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-form-row v-if="$can('edit-customer-detail') || $can('view-all')" class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
    import { fetchActivePaymentTerms } from '../../../../../utils/paymentTerms'
    import { fetchActiveShippingMethods } from '../../../../../utils/shippingMethods'

	export default {
		props: [
            'row'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-customers-edit-customer',
                paymentConfig: {
                    cvc_required: false
                },
                edit: {
                    id: null,
                    name: '',
                    email: '',
                    buyerName: '',
                    phone: '',
                    fax: '',
                    mobile: '',
                    website: '',
                    salesRepId: null,
                    deliveryMethod: '',
                    paymentMethod: '',
                    billingAddress1: '',
                    billingAddress2: '',
                    billingCity: '',
                    billingState: '',
                    billingZip: '',
                    billingCountry: '',
                    shippingAddress1: '',
                    shippingAddress2: '',
                    shippingCity: '',
                    shippingState: '',
                    shippingZip: '',
                    shippingCountry: '',
                    notes: '',
                    openingBalance: '',
                    resellersPermit: '',
                    new: {
                        number: '',
                        exp: '',
                        cvc: ''
                    }
                },
                newUser: {},
                mapUser: {},
                newPassword: '',
                ready: 0,
                lists: {
                    cards: [],
                    paymentMethods: [],
                    deliveryMethods: [],
                    salesReps: [],
                    sources: []
                },
                submitting: 0,
                submittingPassword: 0,
                submittingNewUser: 0,
                submittingUnlink: 0,
                submittingMapUserId: 0
			}
		},

		methods: {
            mapUserId() {
                this.submittingMapUserId = 1

                let url = 'api/lists/customers/mapwoouserid'
                axios.post(url, {
                    id: this.mapUser.id,
                    username: this.mapUser.username,
                    customerId: this.row.id
                })
                .then((res) => {
                    this.submittingMapUserId = 0

                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'User Mapped', 'Woo user mapped successfully!')
                        this.$emit('getRow')
                    } else if (res.data.status == 'duplicate') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in system. Please try another username!')
                    }
                    // } else if (res.data.status == 'duplicatewoo') {
                    //     this.showAlertBox('error', 'Duplicate Username', 'Username already exists in Woo. Please try another username!')
                    // } else if (res.data.status == 'error') {
                    //     this.showAlertBox('error', 'API Error', res.data.error)
                    // } else {
                    //     this.showAlertBox('error', 'Error', 'Error creating user!')
                    // }
                }, () => {
                    this.has_error = true
                })
            },

            createNewUser() {
                this.submittingNewUser = 1

                let url = 'api/lists/customers/createnewwoouser'
                axios.post(url, {
                    username: this.newUser.username,
                    password: this.newUser.password,
                    customerId: this.row.id
                })
                .then((res) => {
                    this.submittingNewUser = 0

                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'User Created', 'Woo user created successfully!')
                        this.$emit('getRow')
                    } else if (res.data.status == 'duplicate') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in system. Please try another username!')
                    } else if (res.data.status == 'duplicatewoo') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in Woo. Please try another username!')
                    } else if (res.data.status == 'error') {
                        this.showAlertBox('error', 'API Error', res.data.error)
                    } else {
                        this.showAlertBox('error', 'Error', 'Error creating user!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            resetPassword(sourceId, wooId) {
                this.submittingPassword = 1

                let url = 'api/lists/customers/resetsourcepassword'
                axios.post(url, {
                    newPassword: this.newPassword,
                    wooId: wooId,
                    username: this.row.username,
                    email: this.row.email,
                    sourceId: sourceId
                })
                .then((res) => {
                    this.submittingPassword = 0

                    if (res.data.status == 'success') {
                        this.newPassword = ''
                        this.showAlertBox('success', 'Password Reset', 'Customer password has been updated successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error updating customer password!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            unlinkSource(trackerId, sourceId, wooId) {
                this.submittingUnlink = 1

                let url = 'api/lists/customers/unlinksource'
                axios.post(url, {
                    wooId: wooId,
                    trackerId: trackerId,
                    sourceId: sourceId
                })
                .then((res) => {
                    this.submittingUnlink = 0

                    if (res.data.status == 'success') {
                        this.getSources()
                        this.$emit('getRow')
                        this.row.username = ''
                        this.row.password = ''
                        this.row.email = ''
                        this.showAlertBox('success', 'Unlink Source', 'Source unlinked from customer successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error unlinking source from customer!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getPaymentTerms() {
                fetchActivePaymentTerms().then((terms) => {
                    this.lists.paymentMethods = terms
                })
            },

            getShippingMethods() {
                fetchActiveShippingMethods().then((methods) => {
                    this.lists.deliveryMethods = methods
                })
            },

            getSalesReps() {
                let url = 'api/lists/sales-reps/getsalesreps/'
                axios.get(url, {})
                .then((res) => {
                    this.lists.salesReps = res.data.salesReps
                }, () => {
                    this.has_error = true
                })
            },

            async loadPaymentConfig() {
                try {
                    const response = await axios.get('/api/payments/config')
                    if (response.data.success) {
                        this.paymentConfig = response.data.config
                    }
                } catch (error) {
                    console.warn('Could not load payment configuration, using defaults')
                }
            },

            getCards() {
                let url = 'api/lists/customers/getcards/' + this.row.id
                axios.get(url, {})
                    .then((res) => {
                        this.lists.cards = res.data.cards
                    }, () => {
                        this.has_error = true
                    })
            },

            getSources() {
                let url = 'api/company/sources/getsources/'
                axios.get(url, {})
                .then((res) => {
                    this.lists.sources = res.data.sources
                }, () => {
                    this.has_error = true
                })
            },

            editCustomer(forceUpdate = false) {
                this.submitting = 1
                
                // Prepare the data in the format the backend expects
                let editData = {
                    id: this.edit.id,
                    name: this.edit.name,
                    email: this.edit.email,
                    buyers_name: this.edit.buyerName,
                    phone: this.edit.phone,
                    fax: this.edit.fax,
                    mobile: this.edit.mobile,
                    website: this.edit.website,
                    sales_rep_id: this.edit.salesRepId,
                    shipping_method: this.edit.deliveryMethod,
                    payment_method: this.edit.paymentMethod,
                    billing_address_1: this.edit.billingAddress1,
                    billing_address_2: this.edit.billingAddress2,
                    billing_city: this.edit.billingCity,
                    billing_state: this.edit.billingState,
                    billing_postal_code: this.edit.billingZip,
                    billing_country: this.edit.billingCountry,
                    shipping_address_1: this.edit.shippingAddress1,
                    shipping_address_2: this.edit.shippingAddress2,
                    shipping_city: this.edit.shippingCity,
                    shipping_state: this.edit.shippingState,
                    shipping_postal_code: this.edit.shippingZip,
                    shipping_country: this.edit.shippingCountry,
                    notes: this.edit.notes,
                    starting_balance: this.edit.openingBalance,
                    resellers_permit: this.edit.resellersPermit
                }

                let url = 'api/lists/customers/updatecustomer'
                axios.post(url, {
                    editData,
                    force_update: forceUpdate
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Customer Updated', 'Customer ' + editData.name + ' updated successfully!')
                        this.$emit('getRow')
                    } else if (res.data.status == 'warning') {
                        // Handle duplicate warning with confirmation dialog
                        this.showDuplicateConfirmation(res.data)
                    } else {
                        this.showAlertBox('error', 'Error', 'Error updating customer!')
                    }
                }, (error) => {
                    this.submitting = 0
                    if (error.response && error.response.data) {
                        const errorData = error.response.data
                        const errorMessage = errorData.message || 'Error updating customer!'
                        this.showAlertBox('error', 'Error', errorMessage)
                    } else {
                        this.has_error = true
                    }
                })
            },
            
            showDuplicateConfirmation(data) {
                const existing = data.existing_customer
                const matchedFields = data.matched_fields || []
                
                // Build the confirmation message
                let message = 'A potential duplicate customer was found.\n\n'
                message += 'Matched fields: ' + matchedFields.join(', ') + '\n\n'
                message += 'Existing Customer Details:\n'
                
                if (existing.name) {
                    message += '• Name: ' + existing.name + '\n'
                }
                if (existing.email) {
                    message += '• Email: ' + existing.email + '\n'
                }
                if (existing.phone) {
                    message += '• Phone: ' + existing.phone + '\n'
                }
                if (existing.billing_address_1) {
                    message += '• Billing Address: ' + existing.billing_address_1 + '\n'
                }
                if (existing.shipping_address_1) {
                    message += '• Shipping Address: ' + existing.shipping_address_1 + '\n'
                }
                
                message += '\nDo you want to still update this customer?'
                
                // Show confirmation dialog
                this.$bvModal.msgBoxConfirm(message, {
                    title: 'Duplicate Customer Warning',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        // User confirmed - update customer anyway
                        this.editCustomer(true)
                    }
                    // If user clicks No, do nothing (form stays open)
                })
                .catch(err => {
                    // User cancelled or error occurred
                })
            },

            populateRow() {
                this.edit.id = this.row.id
                this.edit.name = this.row.name
                this.edit.email = this.row.email
                this.edit.buyerName = this.row.buyers_name
                this.edit.phone = this.row.phone
                this.edit.fax = this.row.fax
                this.edit.mobile = this.row.mobile
                this.edit.website = this.row.website
                this.edit.salesRepId = this.row.sales_rep_id
                this.edit.deliveryMethod = this.row.shipping_method
                this.edit.paymentMethod = this.row.payment_method
                this.edit.billingAddress1 = this.row.billing_address_1
                this.edit.billingAddress2 = this.row.billing_address_2
                this.edit.billingCity = this.row.billing_city
                this.edit.billingState = this.row.billing_state
                this.edit.billingZip = this.row.billing_postal_code
                this.edit.billingCountry = this.row.billing_country
                this.edit.shippingAddress1 = this.row.shipping_address_1
                this.edit.shippingAddress2 = this.row.shipping_address_2
                this.edit.shippingCity = this.row.shipping_city
                this.edit.shippingState = this.row.shipping_state
                this.edit.shippingZip = this.row.shipping_postal_code
                this.edit.shippingCountry = this.row.shipping_country
                this.edit.notes = this.row.notes
                this.edit.openingBalance = this.row.starting_balance
                this.edit.resellersPermit = this.row.resellers_permit

                this.ready = 1
            },

            async makeDefault(cardId) {
                let url = 'api/lists/customers/makedefaultcard/' + this.row.id + '/' + cardId;
                try {
                    let res = await axios.post(url);
                    if (res.data.status === 'Success') {
                        this.lists.cards.forEach(card => { card.default = false; });
                        let found = this.lists.cards.find(card => card.id === cardId);
                        if (found) found.default = true;
                        this.$forceUpdate();
                    } else {
                        this.showAlertBox('error', 'Error', 'Failed to set default card!');
                    }
                } catch (e) {
                    this.showAlertBox('error', 'Error', 'Failed to set default card!');
                }
            },

            deleteCard(cardId) {
                if (!window.confirm('Are you sure you want to delete this card?')) return;
                let url = 'api/lists/customers/deletecard/' + cardId
                axios.get(url, {})
                    .then((res) => {
                        this.getCards()
                    }, () => {
                        this.has_error = true
                    })
            },

                         createCard() {
                // Validate CVC if required by configuration
                if (this.paymentConfig.cvc_required && !this.edit.new.cvc.trim()) {
                    this.showAlertBox('error', 'Validation Error', 'CVC is required for card creation')
                    return
                }
                
                let url = 'api/lists/customers/createcard'
                axios.post(url, {
                    customerId: this.row.id,
                    number: this.edit.new.number.trim(),
                    exp: this.edit.new.exp.trim(),
                    cvc: this.edit.new.cvc ? this.edit.new.cvc.trim() : null
                })
                     .then((res) => {
                         this.submitting = 0

                         if (res.data.status == 'Success') {
                             this.edit.new = {
                                 number: '',
                                 exp: '',
                                 cvc: ''
                             }
                            this.getCards()
                         } else {
                             this.showAlertBox('error', 'Error', res.data.message || 'Error adding card!')
                         }
                     }, (err) => {
                         this.has_error = true
                         if (err.response && err.response.data && err.response.data.message) {
                             this.showAlertBox('error', 'Error', err.response.data.message)
                         } else {
                             this.showAlertBox('error', 'Error', 'Error adding card!')
                         }
                     })
             },

             formatCardNumber() {
                 // Remove all non-digit characters and limit to 16 digits
                 if (this.edit.new.number) {
                     this.edit.new.number = this.edit.new.number.replace(/\D/g, '').substring(0, 16);
                 }
             },

             formatExpiry() {
                 // Remove all non-digit characters and format as MM/YY
                 if (this.edit.new.exp) {
                     let value = this.edit.new.exp.replace(/\D/g, '');
                     if (value.length >= 2) {
                         value = value.substring(0, 2) + '/' + value.substring(2, 4);
                     }
                     this.edit.new.exp = value.substring(0, 5);
                 }
             },

             formatCVC() {
                 // Remove all non-digit characters and limit to 4 digits (for Amex)
                 // Preserve leading zeros by treating as string
                 if (this.edit.new.cvc) {
                     let cleaned = this.edit.new.cvc.replace(/\D/g, '');
                     this.edit.new.cvc = cleaned.substring(0, 4);
                 }
             },

            showAlertBox(type, title, message) {
                // Simple alert box implementation
                if (type === 'success') {
                    this.$bvToast.toast(message, {
                        title: title,
                        variant: 'success',
                        solid: true,
                        autoHideDelay: 5000
                    })
                } else if (type === 'error') {
                    this.$bvToast.toast(message, {
                        title: title,
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 8000
                    })
                }
            },

             formatCardDisplay(value, fieldType) {
                 // Check if user has permission to view full card details
                 const canViewFullCard = this.$can('view-customer-detail-payment-method-full-card') || this.$can('view-all')
                 
                 if (!value) return ''
                 
                 if (canViewFullCard) {
                     // Show full details with formatting
                     if (fieldType === 'number') {
                         // Format card number with dashes for better readability
                         const cleaned = value.replace(/\D/g, '')
                         const formatted = cleaned.replace(/(\d{4})(?=\d)/g, '$1-')
                         return formatted.slice(0, 19) // Ensure it doesn't exceed 19 characters
                     } else if (fieldType === 'exp') {
                         return value
                     } else if (fieldType === 'cvc') {
                         return value
                     }
                 } else {
                     // Mask sensitive information
                     if (fieldType === 'number') {
                         // Show only last 4 digits
                         if (value.length > 4) {
                             return 'XXXX-XXXX-XXXX-' + value.substring(value.length - 4)
                         }
                         return value
                     } else if (fieldType === 'exp') {
                         // Always show expiration date, never mask it
                         return value
                     } else if (fieldType === 'cvc') {
                         return 'XXX'
                     }
                 }
                 
                 return value
             },

             closeModal(modalName) {
                 this.$bvModal.hide(modalName)
             }
		},

		computed: {
            idTracker() {
                return this.row.id_tracker.filter(i => {
                    return i.source && i.source.active == 1;
                })
            }
		},

		mounted() {
            this.getSalesReps()
            this.getPaymentTerms()
            this.getShippingMethods()
            this.loadPaymentConfig()
            this.getSources()
            this.populateRow()
            this.getCards()
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-edit-customer {
        .modal-dialog {
            max-width: 900px;
        }

        .modal-content {
            .default-card {
                width: 1px;
            }

            .highlight-green {
                background-color: green;
            }

            .button-row {
                margin-top: 15px;
            }

            .sources-first-col {
                width: 105px;
            }

            .table {
                width: 100%;
            }
        }
    }
</style>
